

import { Section } from './section';

// Download
export class FileInfo {
	[key: string]: string | number | boolean | Section[];

	dlAllgemein = false;
	dlBereich = '';
	dlBezeichnung = '';
	dlDateiName = '';
	dlGueltigAb = 0;
	dlGueltigBis = 0;
	dlId = '';
	dlPfad = '';

	mitgliedId = '';
	sparten: Section[] = [];

}

// Gruppe
export class Group {
	[key: string]: string;

	gruppenId = "";
	gruppenname = "";
	gruppeBeshreibung = "";
}

export class Folder {
	folderId = "";
	folderName = "";
	folderPath = "";
}

// GruppeFolder
export class GroupFolder {

	folderId = "";
	folderPath = "";
	gfId = "";
	gruppenId = "";

	unassign = false;
}

// MitgliedGruppe
export class MemberGroup {
	gruppenId = "";
	mgId = "";
	mitgliedId = "";

	unassign = false;
}

// Datei
export class FileDetails {
	
	fileName = "";
	fileRelativePfad = "";
	folder = false;
	hash = "";

	bCollapsed = false;

}



export class FileBranch {

	folder = new FileDetails();

	files: FileDetails[] = [];

	subBranches: FileBranch[] = [];


	constructor() {}

}





export class MyFile {

	file: File = new File( [], "fileNameNotInitialized" );
	id = "";
	percentageUploaded = 0;

}

export class CalAndNewsFileInfo {

	dateiId = "";
	dateiName = "";
	dateiVerzeichnis = "";
	veranstaltungId = "";

}
